import React, { useEffect, useState } from 'react';
import axios from 'axios';

const initialForm = {
  name: '',
  email: '',
  code: '',
};

const AdministratorReferrals = () => {
  const [referrals, setReferrals] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const fetchReferrals = () => {
    setLoading(true);
    setError('');

    axios
      .get('/api/administrator/referrals')
      .then((response) => setReferrals(response.data || []))
      .catch(() => setError('No fue posible cargar los referidos.'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchReferrals();
  }, []);

  const openModal = () => {
    setForm(initialForm);
    setError('');
    setShowModal(true);
  };

  const closeModal = () => {
    if (!saving) {
      setShowModal(false);
      setForm(initialForm);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({
      ...current,
      [name]: name === 'code' ? value.toUpperCase() : value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSaving(true);
    setError('');

    axios
      .post('/api/administrator/referrals', form)
      .then(() => {
        setShowModal(false);
        setForm(initialForm);
        fetchReferrals();
      })
      .catch((err) => {
        const validationErrors = err?.response?.data?.errors;
        const firstValidationError = validationErrors
          ? Object.values(validationErrors).flat()[0]
          : null;

        setError(firstValidationError || err?.response?.data?.message || 'No fue posible guardar el referido.');
      })
      .finally(() => setSaving(false));
  };

  return (
    <div className="administrator-referrals">
      <div className="administrator-page-heading d-flex justify-content-between align-items-center mb-5">
        <div>
          <h1>Referidos</h1>
          <p>Consulta y administra los códigos de referido registrados.</p>
        </div>
        <button type="button" className="btn administrator-primary-button font-weight-bolder" onClick={openModal}>
          <i className="fas fa-plus mr-2" />
          Agregar referido
        </button>
      </div>

      {error && !showModal && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <div className="referrals-table-card">
        <div className="card-body p-0">
      {loading ? (
        <p className="text-muted mb-0 p-5">Cargando...</p>
      ) : referrals.length === 0 ? (
        <p className="text-muted mb-0 p-5">No hay códigos de referido registrados.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-head-custom table-vertical-center mb-0">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Correo</th>
                <th>Código de referido</th>
                <th className="text-center">Registros</th>
                <th>Fecha de alta</th>
              </tr>
            </thead>
            <tbody>
              {referrals.map((referral) => (
                <tr key={referral.id}>
                  <td>{referral.name}</td>
                  <td>{referral.email}</td>
                  <td><span className="label label-light-primary label-inline font-weight-bolder">{referral.code}</span></td>
                  <td className="text-center">{referral.people_count || 0}</td>
                  <td>{new Date(referral.created_at).toLocaleDateString('es-MX')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
        </div>
      </div>

      {showModal && (
        <>
          <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <form onSubmit={handleSubmit}>
                  <div className="modal-header">
                    <h5 className="modal-title">Agregar referido</h5>
                    <button type="button" className="close" aria-label="Cerrar" onClick={closeModal} disabled={saving}>
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    {error && (
                      <div className="alert alert-danger" role="alert">
                        {error}
                      </div>
                    )}

                    <div className="form-group">
                      <label className="font-weight-bolder" htmlFor="referral-name">Nombre</label>
                      <input id="referral-name" type="text" name="name" className="form-control form-control-solid" value={form.name} onChange={handleChange} maxLength="255" required autoFocus />
                    </div>

                    <div className="form-group">
                      <label className="font-weight-bolder" htmlFor="referral-email">Correo</label>
                      <input id="referral-email" type="email" name="email" className="form-control form-control-solid" value={form.email} onChange={handleChange} maxLength="255" required />
                    </div>

                    <div className="form-group mb-0">
                      <label className="font-weight-bolder" htmlFor="referral-code">Código de referido</label>
                      <input id="referral-code" type="text" name="code" className="form-control form-control-solid" value={form.code} onChange={handleChange} maxLength="100" required />
                      <small className="form-text text-muted">Puede contener letras, números y símbolos.</small>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-light-primary font-weight-bolder" onClick={closeModal} disabled={saving}>Cancelar</button>
                    <button type="submit" className="btn btn-primary font-weight-bolder" disabled={saving}>
                      {saving ? 'Guardando...' : 'Guardar'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
    </div>
  );
};

export default AdministratorReferrals;
